import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import PropTypes from 'prop-types';
import { changeStatusReasonForEditCrqId } from 'AppSrc/core/actions/actions-edit-form';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-actions.css';

const PostponeCrqModalDisplay = ({
  closeModal,
  postponeCrqStatus,
  postponeCrq,
  network,
}) => {

  const [selectedReason] = useState('Reason1');
  const handleCancelCrq = () => {
    postponeCrq(selectedReason);
    postponeCrqStatus();
    closeModal();
  };


  return (
    <ModalPortal>
      <div
        className="v-f-modal-section cancel-crq-modal"
      >
        <div className="v-f-modal-shadow" />
        <div className="v-f-modal-inner">
          <div className="cancel-crq-modal-content">
            <div className="headText">
              <h3>
                Are you sure you want to postpone this CRQ?
              </h3>
            </div>
            {network === 'fixed' ? (
              <div className="lblText">
                This CRQ will be moved back to Coordinator review and postponed comms will be sent if applicable.
              </div>
            ) : (
              <div className="lblText">
                This CRQ will be moved back to Coordinator review. Please notify Change Management so postponement comms can be sent where applicable.
              </div>
            )}
            <div className="form-modal-options form-modal-options-space-maker" />
            <div className="form-modal-options">
              <div className="side-left">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={closeModal}
                >
                  Back
                </button>
              </div>
              <div className="side-right">
                <button
                  type="button"
                  className="save-button save-button-ready"
                  onClick={handleCancelCrq}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

PostponeCrqModalDisplay.propTypes = {
  closeModal: PropTypes.func,
  postponeCrqStatus: PropTypes.func,
  postponeCrq: PropTypes.func,
  network: PropTypes.string,
};

const PostponeAlertModal = ({ closeModal }) => (
  <ModalPortal>
    <div
      className="v-f-modal-section cancel-crq-modal"
    >
      <div className="v-f-modal-shadow" />
      <div className="v-f-modal-inner">
        <div className="cancel-crq-modal-content">
          <div className="headText">
            <h3>
              This CRQ cannot be postponed anymore as the postponement action limit has been reached.
            </h3>
          </div>
          {/* <div className="lblText">
            This CRQ will be moved back to Cordinator review and Postponed comms will be sent id applicable
          </div> */}
          <div className="form-modal-options form-modal-options-space-maker" />
          <div className="form-modal-options">
            <div className="side-left">
              {/* <button
                type="button"
                className="cancel-button"
                onClick={closeModal}
              >
                Back
              </button> */}
            </div>
            <div className="side-right">
              <button
                type="button"
                className="save-button save-button-ready"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ModalPortal>
);


PostponeAlertModal.propTypes = {
  closeModal: PropTypes.func,
};


const mapDispatchToProps = (dispatch, ownProps) => ({
  postponeCrq(statusReason) {
    const {
      crqId,
    } = ownProps;
    // clear the status_reason when rejecting from peer review
    dispatch(changeStatusReasonForEditCrqId({
      crqId,
      statusReason: statusReason ? statusReason : null,
    }));
  },
});

const PostponeCrqModal = connect(
  null,
  mapDispatchToProps,
)(PostponeCrqModalDisplay);

export { PostponeCrqModal, PostponeAlertModal };
